import { useRef, useState } from "react";

import { Filter as FilterIcon } from "neetoicons";
import { Form } from "neetoui/formik";

import { FILTER_INITIAL_VALUES, FILTER_VALIDATION_SCHEMA } from "./constants";
import Modal from "./Modal";

const Filter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  return (
    <div className="relative" ref={wrapperRef}>
      <FilterIcon
        className="cursor-pointer rounded-md border border-transparent p-1 hover:border-gray-600 hover:bg-white"
        color="#808080"
        fill="white"
        size={32}
        onClick={() => setIsOpen(!isOpen)}
      />
      <Form
        formikProps={{
          initialValues: FILTER_INITIAL_VALUES,
          validationSchema: FILTER_VALIDATION_SCHEMA,
          validateOnMount: true,
          validateOnChange: true,
        }}
      >
        <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      </Form>
    </div>
  );
};

export default Filter;
